import React from "react";

import Map from "../components/map";
import data from "../data/data";

import "../styles/contact-us.scss";

const ContactUs = (props) => {
  return (
    <div className="contact-page">
      <div className="contact-page__content">
        <section className="contact__address">
          <div className="contact__address-container">
            <div className="contact__address-header">
              <h2 className="contact-headings">
                Were We <span>Are</span>
              </h2>
            </div>
            <div className="contact__address-content">
              <address>
                <div>30 Rambler Drive Unit 2</div>
                <div>Brampton, ON L6W 1E2</div>
                <div>Canada</div>
              </address>
            </div>
          </div>
        </section>
        <section className="contact__contact-info">
          <div className="contact__contact-info-container">
            <div className="contact__contact-header">
              <h2 className="contact-headings">
                Contact <span>Us</span>
              </h2>
            </div>
            <div className="contact__contact-content">
              <div>
                <a href="tel:+12894011359">+1(289)-401-1359</a>
              </div>
              <div>
                <a href="tel:+12894011359">+1(800)-234-5679</a>
              </div>
              <div>
                <a href="#">mail@restaurant.com</a>
              </div>
            </div>
          </div>
        </section>
        <section className="contact__working-hours">
          <div className="contact__working-hours-container">
            <div className="contact__working-hours-header">
              <h2 className="contact-headings">
                We Are <span>Open</span>
              </h2>
            </div>
            <div className="contact__working-content">
              <div className="contact-working-weekdays">
                <h2>Weekdays</h2>
                {data.timings.map(
                  (day, index) =>
                    index < 5 && (
                      <div className="contact__working-timings">
                        <span className="contact__working-day">{day.day}:</span>{" "}
                        <span className="contact__working-time">
                          {day.hours}
                        </span>
                      </div>
                    )
                )}
              </div>
              <div className="contact-working-weekends">
                <h2>Weekends</h2>
                {data.timings.map(
                  (day, index) =>
                    index > 4 && (
                      <div className="contact__working-timings">
                        <span className="contact__working-day">{day.day}:</span>{" "}
                        <span className="contact__working-time">
                          {day.hours}
                        </span>
                      </div>
                    )
                )}
              </div>
            </div>
          </div>
        </section>
        <section className="contact__map">
          <Map />
        </section>
      </div>
    </div>
  );
};

export default ContactUs;
